module.exports = __webpack_public_path__ + "static/Aneta_Koubkova_MyHeartWillGoOn-1c63b27495b430241a96549e96d6b01d.mp3";